import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

export type DeleteAutomationVariables = {
  id: string;
};

export async function deleteAutomationFn(
  axiosInstance: Promise<AxiosInstance>,
  variables: DeleteAutomationVariables,
): Promise<ApiResponse> {
  const { id } = variables;
  const instance = await axiosInstance;

  return instance.delete(`automations/${id}`);
}

export function useDeleteAutomation() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeleteAutomationVariables>({
    mutationFn: variables => deleteAutomationFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['automationIndex'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    DeleteAutomationVariables,
    'deleteAutomation'
  >('deleteAutomation', mutation);
}
